module.exports = __webpack_public_path__ + "img/lr.c516061b.png";